import * as React from "react";
import {
    Toolbar,
    Button,
    ButtonGroup,
} from "@progress/kendo-react-buttons";
import {
    Form,
    Field,
    FormElement,
    FormRenderProps,
    FormSubmitClickEvent,
} from "@progress/kendo-react-form";

import { StackLayout } from "@progress/kendo-react-layout";
import { requiredValidator } from "./validators";

import { FormDatePicker, FormCheckbox, FormInput } from "./FormComponents";

import { useEditTobaccoMutation } from '../store/sunbright-api';

export interface TobaccoNewProps {
    onReturn?: any;
    uid: number;
    regionid: number;
    eventid: number;
    row: number;
    editValues: any;
}

const TobaccoNew = ({
    onReturn,
    uid,
    regionid,
    eventid,
    row,
    editValues
}: TobaccoNewProps) => {

    const [editTobacco, response] = useEditTobaccoMutation();

    const TobaccoForm = React.useRef<any>(null);

    const [formHeight, setFormHeight] = React.useState<string>("100px");

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
        setFormHeight((window.innerHeight - 90) + "px");
    }, []);

    const handleResize = () => {
        setFormHeight((window.innerHeight - 90) + "px");
    };

    const submitForm = (event: FormSubmitClickEvent) => {

        const { isValid } = event;

        if (isValid) {
            const postTobacco = TobaccoForm.current.values;

            postTobacco.uid = uid;
            postTobacco.regionid = regionid;
            postTobacco.eventid = eventid;
            postTobacco.row = row;

            editTobacco(postTobacco)
                .unwrap()
                .then((payload) => { })
                .catch((error) => {
                    console.log(error)
                });

            onReturn(true);
        }
    }

    return (
        <React.Fragment>

            <div
                style={{ overflow: "auto", marginLeft: "16px" }}
                className={"sds-bold"}
            >
                <Form
                    ref={TobaccoForm}
                    onSubmitClick={submitForm}
                    initialValues={editValues}
                   render={(formRenderProps: FormRenderProps) => (
                        <div>
                             <Toolbar>
                                    <Button
                                    icon="save"
                                        onClick={formRenderProps.onSubmit}
                                    >
                                        Save
                                    </Button>
                                <ButtonGroup>
                                    <Button
                                        icon="cancel"
                                        onClick={(e) => onReturn(false)}
                                    >
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </Toolbar>
                           <div style={{ alignSelf: "center" }}>
                                <FormElement
                                    style={{ height: formHeight, overflow: "auto", marginLeft: "16px", marginRight: "32px" }}>
                                    <div className={"sds-questionnaire"}>
                                        <fieldset
                                            style={{}}
                                            className={"k-form-fieldset"}
                                        >
                                            <legend
                                                style={{ paddingTop: "24px" }}
                                                className={"k-form-legend"}>
                                                Client
                                            </legend>

                                            <StackLayout gap={18}>
                                                <Field
                                                    label={"Name"}
                                                    name={"name"}
                                                    component={FormInput}
                                                />
                                                <Field
                                                    label={"Phone #"}
                                                    name={"phone"}
                                                    component={FormInput}
                                                />
                                                <Field
                                                    label={"Email"}
                                                    name={"email"}
                                                    component={FormInput}
                                                />
                                                <div/>
                                           </StackLayout>
                                            <StackLayout gap={18}>
                                                <Field
                                                    label={"Gender"}
                                                    name={"gender"}
                                                    component={FormInput}
                                                />
                                                <Field
                                                    label={"Age (years)"}
                                                    name={"age"}
                                                    component={FormInput}
                                                />
                                                <Field
                                                    label={"# Years Smoked"}
                                                    name={"yearssmoked"}
                                                    component={FormInput}
                                                />
                                                <Field
                                                    label={"# Cigs/Day "}
                                                    name={"cigsperday"}
                                                    component={FormInput}
                                                />
                                           </StackLayout>
                                            <StackLayout gap={18}>
                                                <Field
                                                    label={"Patches"}
                                                    name={"patches"}
                                                    component={FormInput}
                                                />
                                                <Field
                                                    label={"Gum"}
                                                    name={"gum"}
                                                    component={FormInput}
                                                />
                                                <Field
                                                    label={"Lozenges"}
                                                    name={"lozenges"}
                                                    component={FormInput}
                                                />
                                                <div />
                                           </StackLayout>
                                            <StackLayout gap={18}>
                                                <div style={{ marginTop: "16px" }}>
                                                    <Field
                                                        label={"Verbal Consent"}
                                                        name={"consent"}
                                                        component={FormCheckbox}
                                                        style={{ borderColor: "black" }}
                                                    />
                                                </div>
                                               <div style={{marginTop:"16px"} }>
                                                    <Field
                                                        label={"OMSC Referral"}
                                                        name={"omscreferral"}
                                                        component={FormCheckbox}
                                                        style={{ borderColor: "black" }}
                                                   />
                                                </div>
                                                <Field
                                                    label={"Voucher Number"}
                                                    name={"vouchernumber"}
                                                    component={FormInput}
                                                />
                                                <Field
                                                    label={"ExamID"}
                                                    name={"examid"}
                                                    component={FormInput}
                                                />
                                            </StackLayout>
                                        </fieldset>
                                    </div>
                                </FormElement>
                            </div>
                        </div>
                    )}
                />
            </div>
        </React.Fragment>
    );
};
export default TobaccoNew;
